module.exports = __webpack_public_path__ + "img/PK.eac3de17.svg";